import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { ManagePageVM } from './manage-page.viewmodel';
import DefaultButton from '../../../../../global/default-button/default-button';
import { SidebarFooter } from '../../_sidebar-footer/sidebar-footer';
import { MANAGE_PAGE_SELECT_LABEL_TEXT, NEW_PAGE_BUTTON_TEXT, SAVE_PAGE_BUTTON_TEXT, } from '../../../../event-hubs.text';
import { CANCEL_TEXT } from '../../../../../../constants/common-labels.constants';
import { CustomPagePresentation } from './_custom-page/custom-page.presentation';
import { PageSelectorDropdown } from './page-selector-dropdown/page-selector-dropdown';
import './manage-page.scss';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';

export type ManagePagePresentationProps = {
    vm: ManagePageVM;
};

export const ManagePagePresentation: React.FC<ManagePagePresentationProps> = observer(({ vm }) => {
    const managePageAndModulesPermission = hasPermission(Permission.HUB_MANAGE_PAGES_AND_MODULES);

    return (
        <div className='manage-page'>
            <div className='manage-page__header'>
                <PageSelectorDropdown
                    className='manage-page__field'
                    prefix={<FormattedMessage {...MANAGE_PAGE_SELECT_LABEL_TEXT} />}
                    selectedLabel={vm.getSelectedPageNameLabel()}
                    selectedLabelItalic={vm.isSelectedPageNamePlaceholder()}
                    options={vm.getPageOptions()}
                    selectedValue={vm.getSelectedPageId()}
                    onChange={vm.selectPage}
                    disabled={vm.isDropdownDisabled()}
                />
                {managePageAndModulesPermission &&
                    <DefaultButton
                        modifier='slim'
                        className='manage-page__new-page-btn'
                        text={<FormattedMessage {...NEW_PAGE_BUTTON_TEXT} />}
                        onClick={vm.onNewPage}
                        disabled={vm.isCreateMode()}
                    />
                }
            </div>
            <div className='manage-page__body'>
                <CustomPagePresentation vm={vm.getSelectedPageVM()} />
            </div>
            <SidebarFooter>
                <DefaultButton
                    modifier='cancel'
                    text={<FormattedMessage {...CANCEL_TEXT} />}
                    onClick={vm.onCancel}
                    disabled={vm.isCancelDisabled()}
                />
                {managePageAndModulesPermission &&
                    <DefaultButton
                        text={<FormattedMessage {...SAVE_PAGE_BUTTON_TEXT} />}
                        onClick={vm.onSavePage}
                        disabled={vm.isSaveButtonDisabled()}
                    />
                }
            </SidebarFooter>
        </div>
    );
});
